import * as type from '../../types/API/batchItemsType'

export function getBatchItems(payload: any) {
    return {
        type: type.GET_BATCHITEMS,
        payload: payload
    }
}



export function updateBatchItems(payload: any) {
    return {
        type: type.UPDATE_BATCHITEMS,
        payload: payload
    }
}




export function createBatchItems(payload: any) {
    return {
        type: type.CREATE_BATCHITEMS,
        payload: payload
    }
}

export function createSelectBatchItems(payload: any) {
    return {
        type: type.CREATE_SELECT_BATCHITEMS,
        payload: payload
    }
}



